import { useCallback, useState } from "react";

/**
 * Tâche 1168 (Eric 2026-06-17) — Parcours utilisés récemment, en tête du menu.
 *
 * Les fichiers arrivent par lots : cinq vidéos d'une même formation se
 * rattachent au même parcours. Le retrouver dans sa famille à chaque fichier
 * est un geste de trop — les derniers parcours cochés remontent donc en haut
 * du menu.
 *
 * Préférence d'affichage propre à la personne : gardée dans le navigateur,
 * rien à stocker côté serveur. Un SEUL hook pour les deux menus (fiche du
 * fichier et liste de l'explorateur), pour que « récent » veuille dire la
 * même chose des deux côtés.
 */
const STORAGE_KEY = "knoria.pathways.recent";
export const MAX_RECENT = 5;

const readStored = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === "string" && id).slice(0, MAX_RECENT)
      : [];
  } catch {
    // localStorage indisponible : le menu reste utilisable, sans section
    // « récents ».
    return [];
  }
};

export const useRecentPathways = () => {
  const [recentIds, setRecentIds] = useState(readStored);

  const remember = useCallback((pathwayId) => {
    if (!pathwayId) return;
    setRecentIds((prev) => {
      // Le plus récent d'abord, sans doublon : recocher un parcours déjà
      // récent doit le remonter, pas l'ajouter deux fois.
      const next = [pathwayId, ...prev.filter((id) => id !== pathwayId)]
        .slice(0, MAX_RECENT);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // Une préférence d'affichage non gardée n'est pas une erreur à
        // remonter à l'utilisateur.
      }
      return next;
    });
  }, []);

  return { recentIds, remember };
};

export { STORAGE_KEY as RECENT_PATHWAYS_STORAGE_KEY };
export default useRecentPathways;
